<template>
  <div>
    <div class="files-list" v-if="files.length > 0">
      <div v-for="file in files" :key="file.id" class="file-item">
        <b-link class="file-link" @click="downloadFile(file.id)" href="#">
          <b-icon icon="file-earmark-text" class="mr-2"></b-icon>
          {{ fileDisplayName(file) }}
        </b-link>
        <div v-if="allows_crud" class="file-actions">
          <ButtonMedium
            :tooltip_text="$t('toolbar.acts.removeFile')"
            :text_button="``"
            :click_button="() => deleteFile(file)"
            :icon="'trash'"
            :variant="'danger'"
          >
          </ButtonMedium>
        </div>
      </div>
    </div>
    <div v-else class="no-files-message">
      {{ $t("toolbar.acts.noAttachedFiles") }}
    </div>

    <div v-if="allows_crud" class="upload-section">
      <div class="upload-input">
        <b-form-file
          v-model="file"
          :state="!Boolean(file)"
          :placeholder="$t('toolbar.acts.selectOrDragFileHere')"
          :drop-placeholder="$t('toolbar.acts.dragFileHere')"
          aria-describedby="input-file-feedback"
          accept="*"
          size="sm"
        ></b-form-file>
        <b-form-invalid-feedback id="input-file-feedback">{{
          $t("toolbar.acts.ensureUploadBeforeSave")
        }}</b-form-invalid-feedback>
      </div>
      <div class="upload-button">
        <ButtonMedium
          :tooltip_text="``"
          :text_button="$t('toolbar.acts.uploadFile')"
          :click_button="save"
          :icon="''"
          :variant="'primary'"
          :custom_class="Boolean(file) ? 'mb-4' : ''"
          :disabled_button="!Boolean(file)"
          :loading="is_saving"
        >
        </ButtonMedium>
      </div>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { downloadFileByUrl } from "@/utils/utils";

export default {
  name: "ActFiles",
  components: {
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
  },
  props: {
    Act: {
      type: Object,
      required: true,
    },
    allows_crud: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      act: this.Act,
      file: null,
      files: [],
      is_saving: false,
    };
  },
  methods: {
    fileDisplayName(file) {
      // "name" trae el nombre original; la ruta lleva prefijo usuario_fecha y sufijo aleatorio.
      if (file.name) return file.name;
      const path = (file.file || "").split("?")[0].split("/");
      return decodeURIComponent(path[path.length - 1]);
    },
    save() {
      if (!this.file || this.is_saving) return;
      const formData = new FormData();
      formData.append("file", this.file);
      this.is_saving = true;
      this.$restful
        .Post("/common/file/", formData)
        .then((response) => {
          this.act.files.push(response.id);
          this.files.push(response);
          this.file = null;
          return this.patchAct({ files: this.act.files });
        })
        .finally(() => {
          this.is_saving = false;
        });
    },
    deleteFile(file) {
      this.$swal({
        title: this.$t("toolbar.acts.deleteFileConfirmation"),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          let index = this.files.findIndex((x) => x.id == file.id);
          if (index != -1) this.files.splice(index, 1);
          index = this.act.files.findIndex((x) => x == file.id);
          if (index != -1) this.act.files.splice(index, 1);
          this.patchAct({ files: this.act.files });
          this.$restful.Delete(`/common/file/${file.id}/`);
        }
      });
    },
    patchAct(item) {
      return this.$restful
        .Patch(`/cideu/act/${this.act.id}/`, item)
        .then((response) => {
          this.$emit("updated", response);
        });
    },
    downloadFile(file_id) {
      this.$store.dispatch(names.FETCH_FILE, file_id).then((file) => {
        if (file) {
          if (file.file != null) {
            downloadFileByUrl(file.file);
          }
        }
      });
    },
  },
  created() {
    this.act.files.forEach((element) => {
      this.$restful.Get(`/common/file/${element}/`).then((response) => {
        this.files.push(response);
      });
    });
  },
};
</script>

<style scoped>

.files-list {
  display: flex;
  flex-direction: column;
  gap: var(--kl-space-3);
  margin-bottom: var(--kl-space-4);
}

.file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--kl-space-3) var(--kl-space-4);
  background: var(--kl-surface-muted);
  border: 1px solid var(--kl-table-border);
  transition: all 0.2s ease;
}

.file-link {
  flex: 1;
  color: var(--kl-text-link);
  text-decoration: none;
  display: flex;
  align-items: center;
  font-weight: var(--kl-fw-medium);
}

.file-link:hover {
  color: var(--kl-color-primary-hover);
  text-decoration: underline;
}

.file-actions {
  margin-left: var(--kl-space-4);
}

.no-files-message {
  text-align: center;
  padding: var(--kl-space-5);
  color: var(--kl-text-muted);
  font-style: italic;
  background: var(--kl-surface-muted);
  border: 1px dashed var(--kl-table-border);
  margin-bottom: var(--kl-space-4);
}

.upload-section {
  display: flex;
  gap: var(--kl-space-4);
  align-items: flex-start;
  padding: var(--kl-space-4);
  background: var(--kl-surface-muted);
  border: 2px dashed var(--kl-table-border);
  margin-top: var(--kl-space-4);
}

.upload-input {
  flex: 1;
}

.upload-button {
  display: flex;
  align-items: center;
}

/* Responsive */
@media (max-width: 768px) {
  .upload-section {
    flex-direction: column;
  }

  .upload-input {
    width: 100%;
  }

  .file-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .file-actions {
    margin-left: 0;
    margin-top: var(--kl-space-2);
  }
}
</style>